import { AiChatContext as e } from "../context/AiChatContext.mjs";
import { useAiChatStream as t } from "../hooks/useAiChatStream.mjs";
import { usePageContext as n } from "../hooks/usePageContext.mjs";
import { usePropertySelection as r } from "../hooks/usePropertySelection.mjs";
import { useCallback as i, useMemo as a } from "react";
import { jsx as o } from "react/jsx-runtime";
//#region src/providers/AiChatProvider.tsx
var s = ({ children: s, surface: c = "user", onArtifactNavigate: l }) => {
	let { selectedProperty: u, selectProperty: d, clearSelectedProperty: f, consumeSelection: p } = r(), { activePage: m, publishPage: h, dismissPage: g } = n(), _ = m?.context, { messages: v, conversationId: y, isStreaming: b, streamingContent: x, error: S, send: C, abort: w, reset: T } = t({
		onBeforeSend: i((e) => {
			let t = p();
			if (!t) return {
				apiMessage: e,
				pageContext: _
			};
			let { prefix: n, property: r } = t;
			return {
				apiMessage: `${n}\n${e}`,
				subjects: [{
					id: r.id,
					title: r.title
				}],
				pageContext: _
			};
		}, [p, _]),
		surface: c
	}), E = a(() => ({
		surface: c,
		onArtifactNavigate: l,
		messages: v,
		conversationId: y,
		isStreaming: b,
		streamingContent: x,
		error: S,
		selectedProperty: u,
		send: C,
		selectProperty: d,
		clearSelectedProperty: f,
		activePage: m,
		publishPage: h,
		dismissPage: g,
		abort: w,
		reset: T
	}), [
		c,
		l,
		v,
		y,
		b,
		x,
		S,
		u,
		C,
		d,
		f,
		m,
		h,
		g,
		w,
		T
	]);
	return /* @__PURE__ */ o(e.Provider, {
		value: E,
		children: s
	});
};
//#endregion
export { s as AiChatProvider };
